import React, { useEffect, useState } from "react";
import { UserRegistrationContainer } from "../../containers";
import permissions from "../../mocks/menuPermissions.json";
import { camelCase } from "lodash";
import authService from "../../components/api-authorization/AuthorizeService";
import Error from "../Error";

const UserRegistration = (props) => {
  const [roleName, setRoleName] = useState("VOU");
  useEffect(() => {
    getRole();
  }, []);
  const subMenu = "userRegistration";
  const getRole = async () => {
    setRoleName(await authService.getRole());
  };

  if (!permissions[roleName]["menuItems"][subMenu]?.includes("C"))
    return <Error />;
  return <UserRegistrationContainer {...props} />;
};

export default UserRegistration;
